const mEditionAssetSignedStudents = {
  mEditionAssetSignedStudents: {
    alerts: {
      createAcademiaActorResetPassword: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'Los datos para restablecer la contraseña fueron enviados exitosamente.'
      },

      readInscripcionesProyectoExportar: {
        error: 'Un error ha ocurrido. Espera un momento y vuelve a intentarlo.',
        success: 'Listado de alumnos descargado.'
      },

      updateInscripcionEstado: {
        activationSuccess: 'El acceso fue activado exitosamente.',
        deactivationSuccess: 'El acceso fue desactivado exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    buttonPrimary: 'Descargar CSV',

    buttonSecondary: {
      createText: 'Crear Inscripción',
      filterText: 'Filtros Avanzados'
    },

    enrollment: {
      automatic: 'Automática',
      manual: 'Manual'
    },

    files: {
      student: 'alumnos'
    },

    table: {
      thAccess: 'Acceso',
      thContent: 'Contenido',
      thDateAcademy: 'Alta en Academia',
      thDateProject: 'Alta en Curso',
      thEmail: 'Email',
      thProfile: 'Perfil',
      thProgress: 'Progreso',
      thState: 'Estado',
      thStudent: 'Alumno'
    },

    tooltip: {
      access: 'Reenviar Acceso',
      activate: 'Activar Acceso',
      content: 'Ver Contenidos',
      deactivate: 'Desactivar Acceso',
      progress: 'Progreso',
      reload: 'Actualizar'
    }
  }
}

export default mEditionAssetSignedStudents
